import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.ListPage,
  title: 'List Page',
  category: ComponentCategory.Layout,
  showInLibrary: false,
};
